export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="flex-1 w-full">
            <h2 className="text-3xl md:text-4xl font-heading font-black text-foreground-950 mb-6 leading-tight">
              关于<span className="text-primary-500">黑料视频</span>
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                黑料视频成立于2024年，是中文互联网最具影响力的娱乐八卦与内幕曝光平台。我们坚持"拒绝官腔，只爆猛料"的核心理念，打造一个不受资本操控、不被公关洗白的独立吃瓜基地。
              </p>
              <p>
                内容覆盖明星塌房、网红翻车、综艺黑幕、娱乐圈灰色产业等全方位话题。每一条爆料均经过团队多轮交叉验证，确保信息的真实性与时效性。
              </p>
              <p>
                每日凌晨3点准时更新传送门，让吃瓜群众在第一时间获取最热、最新、最深的娱乐圈内幕。我们相信：真话不该被埋没，猛料不该被公关。
              </p>
            </div>

            <div className="flex items-center gap-8 md:gap-12 mt-8 pt-8 border-t border-background-200/60">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500">日更</div>
                <div className="text-xs text-foreground-500 mt-1">全年无休</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500">全网</div>
                <div className="text-xs text-foreground-500 mt-1">多平台覆盖</div>
              </div>
              <div className="w-px h-10 bg-background-300"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-black text-primary-500">直达</div>
                <div className="text-xs text-foreground-500 mt-1">无中间商</div>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[460px]">
            <div className="relative aspect-square rounded-2xl overflow-hidden bg-gradient-to-br from-primary-200/40 via-accent-100/30 to-primary-100/50">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-center">
                  <div className="text-6xl md:text-7xl font-black text-primary-500/30 mb-2">黑料</div>
                  <div className="text-2xl font-bold text-foreground-700">全网最狠吃瓜基地</div>
                </div>
              </div>
              <div className="absolute top-6 left-6 w-20 h-20 rounded-2xl bg-primary-400/30 rotate-12"></div>
              <div className="absolute bottom-10 right-8 w-28 h-28 rounded-full bg-accent-300/30 -rotate-6"></div>
              <div className="absolute top-1/2 right-10 w-16 h-16 rounded-xl bg-primary-300/40 rotate-45"></div>
              <div className="absolute bottom-16 left-10 w-14 h-14 rounded-lg bg-accent-200/50 -rotate-12"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}